import * as _ from "lodash";
import * as angular from "angular";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { UserDataProvider } from "../../data-provider/user.dp";
import { Limit } from "../../models/limit.model";
import { Team } from "../../models/team.model";
import { User } from "../../models/user.model";
import { InviteService } from "../../services/invite.service";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";

let UpdateUserDialogComponent = {
    selector: "vcUpdateUserDialog",
    templateUrl: "/angular/components/user/update-user-dialog.component.html",
    bindings: {
        user: "=",
    },
    controller: class UpdateUserDialogController {
        // * bindings for typescript compiler *
        public user: any;
        // ************************************

        private inviteService: InviteService;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private limitDataProvider: LimitDataProvider;
        private readonly __env: any;

        public userCopy: User;
        public errorMessage = "";
        public products: Array<any>;
        public emails: string[] = [];
        public error = "";
        public usersCount: object;
        public loading: boolean;
        public step = 1;
        public mode: string;

        constructor(
            InviteService: InviteService,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            UserDataProvider: UserDataProvider,
            LimitDataProvider: LimitDataProvider,
            __env: any
        ) {
            this.inviteService = InviteService;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.limitDataProvider = LimitDataProvider;
            this.__env = __env;
            this.products = [this.__env.product1, this.__env.product2];

            UserDataProvider.getUsersCount().then(
                (count: object) => (this.usersCount = count)
            );
        }

        $onInit() {
            this.userCopy = _.cloneDeep(this.user);
            // What this dialog loaded, so a save only applies the team changes
            // made here and keeps teams joined elsewhere since it was opened.
            if (Array.isArray(this.user.teams)) {
                this.userCopy.original_tids = this.user.teams.map(
                    (team: Team) => team.tid
                );
            }
            if (this.user.campaigninviteid) {
                this.mode = "invite";
            } else {
                this.mode = "user";
            }
        }

        save(): void {
            this.loading = true;
            this.errorMessage = "";

            if (this.user.uid) {
                this.updateUser();
            } else {
                this.updateInvite();
            }
        }

        updateUser(): void {
            this.userCopy.update().then(
                (user: object) => {
                    this.toast.success("User updated");
                    angular.extend(this.user, user);
                    this.dialog.hide(this.user);
                    this.loading = false;
                },
                (error: any) => {
                    this.errorMessage = error.message;
                    this.loading = false;
                }
            );
        }

        updateInvite(): void {
            this.inviteService.update(this.userCopy).then(
                (response: object) => {
                    const json = response["data"];
                    this.loading = false;
                    if (json.success) {
                        this.toast.success("Invite Updated");
                        angular.extend(this.user, json.data);
                        this.dialog.hide(this.user);
                    } else {
                        this.errorMessage = json.message;
                    }
                },
                (error: any) => {
                    this.errorMessage = error.message;
                    this.loading = false;
                }
            );
        }

        editStep(step: number) {
            this.step = step;
        }

        finishStep(): void {
            if (this.mode == "user") {
                this.step = this.step == 3 ? 5 : this.step + 1;
            } else {
                if (this.step == 1) this.step = 3;
                else if (this.step == 3) this.step = 5;
                else this.step += 1;
            }
        }

        stepBack(): void {
            if (this.mode == "user") {
                this.step = this.step == 5 ? 3 : this.step - 1;
            } else {
                if (this.step == 3) this.step = 1;
                else if (this.step == 5) this.step = 3;
                else this.step -= 1;
            }
        }

        cancel(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("user", [])
    .component(UpdateUserDialogComponent.selector, UpdateUserDialogComponent);
